import { FieldSpecRepeater } from "../spec-repeater/FieldSpecRepeater";

const AgencyUserRelationshipFields = props => {

  const {
    value,
  } = props

  return (
    <>
      <div className="tgbl-cred-user-relationship-fields tgbl-field-block">
        <div className="tf-pseudo-description" >You can enable/disable the fields to show up in the frontend User Accrediting Agency form</div>
        <FieldSpecRepeater
          name={'agency_user_fields'}
          value={value.user_fields ?? []}
        />
      </div>
    </>
  )
}

export { AgencyUserRelationshipFields }
